/** @format */

import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
	inject
} from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconPlMediaPlay
} from '@dsg-tech/homefield-angular-icons';
import { MediaSourceEnum, ObjectFitEnum } from '../models';
import { ReviewMedia, ReviewSelectedMedia } from '@product-reviews/data-access';

import { CommonModule } from '@angular/common';
import { ReviewPlayButtonComponent } from '../review-play-button/review-play-button.component';
import { Subject } from 'rxjs';

@Component({
	selector: 'product-reviews-review-media',
	templateUrl: './review-media.component.html',
	styleUrl: './review-media.component.scss',
	imports: [CommonModule, HomefieldIconLibraryModule, ReviewPlayButtonComponent]
})
export class ReviewMediaComponent implements OnInit, OnDestroy {
	homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);
	@Input() imageId = 0;
	@Input() media: ReviewMedia;
	@Input() showVideo = false;
	@Input() objectFit = ObjectFitEnum.COVER;
	@Input() mediaSource = MediaSourceEnum.CAROUSEL;
	@Output() selectedMedia = new EventEmitter<ReviewSelectedMedia>();
	@ViewChild('element') element: HTMLImageElement;
	mediaSourceClasses: string[] = [];
	mediaSourceContainerClass = '';

	private UNSUBSCRIBE$ = new Subject<void>();

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconPlMediaPlay]);
	}

	ngOnInit(): void {
		this.mediaSourceClasses = this.buildMediaSouceClasses();
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	handleMedia(): void {
		const selectedMedia = {
			...this.media,
			imageId: this.imageId
		};
		this.selectedMedia.emit(selectedMedia);
	}

	private buildMediaSouceClasses(): string[] {
		const classNames: string[] = [];
		if (this.media) {
			classNames.push(
				this.objectFit === ObjectFitEnum.COVER ? 'object-fit-cover' : 'object-fit-contain'
			);

			if (this.mediaSource === MediaSourceEnum.CAROUSEL_STATIC) {
				classNames.push('source-carousel', 'source-static');
			} else if (this.mediaSource === MediaSourceEnum.CAROUSEL) {
				classNames.push('source-carousel');
			} else if (this.mediaSource === MediaSourceEnum.DRAWER) {
				classNames.push('source-drawer');
			} else if (this.mediaSource === MediaSourceEnum.SECTION) {
				classNames.push('source-section');
				this.mediaSourceContainerClass = 'hmf-display-flex hmf-align-items-center';
			}
			return classNames;
		}
	}
}
